import { inject, Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { BehaviorSubject } from 'rxjs';
import { Meta } from '@angular/platform-browser';
import { GtmService } from './gtm.service';
import { PixelService } from './pixel.service';
import { SettingService } from '../common/setting.service';

@Injectable({
  providedIn: 'root',
})
export class AppConfigService {

  private config: any;

  private configSubject = new BehaviorSubject<any>(null);
  config$ = this.configSubject.asObservable();

  private readonly meta = inject(Meta);
  private readonly pixelService = inject(PixelService);
  private readonly gtmService = inject(GtmService);
  private readonly settingService = inject(SettingService);

  constructor(@Inject(PLATFORM_ID) private platformId: any) {}

  /**
   * loadConfig()
   * initAnalytics()
   */
  loadConfig(): void {
    this.settingService.getSetting('analytics googleSearchConsoleToken')
      .subscribe({
        next: (res) => {
          if (res?.success && res.data) {
            this.config = res.data;
            this.configSubject.next(this.config);
            this.initAnalytics();
          }
        },
        error: (err) => {
          console.warn('[AppConfigService] Failed to load settings:', err);
        }
      });
  }

  private initAnalytics() {
    if (!this.config) return;

    // Google Search Console
    const gscToken = this.config['googleSearchConsoleToken'];
    if (gscToken) {
      this.addGoogleVerification(gscToken);
    }

    if (isPlatformBrowser(this.platformId)) {
      const analytics = this.config['analytics'];
      // console.log('🔍 [AppConfigService] Found Analytics Settings:', analytics);

      // 1. Facebook Pixel — set ID on GtmService + init pixel
      const pixelId: string = analytics?.facebookPixelId || '';
      this.gtmService.facebookPixelId = pixelId;
      // console.log('🔍 [AppConfigService] Facebook Pixel ID:', pixelId);
      if (pixelId) {
        this.pixelService.init(pixelId);
      }

      // 2. GTM / FB Pixel Management flag
      this.gtmService.isManageFbPixelByTagManager = !!analytics?.IsManageFbPixelByTagManager;

      // 3. Tag Manager ID
      this.gtmService.tagManagerId = analytics?.tagManagerId || '';
    }
  }

  private addGoogleVerification(token: string) {
    if (token) {
      this.meta.updateTag({ name: 'google-site-verification', content: token });
    }
  }

  getSettingData(field: string): any {
    return field ? this.config?.[field] : this.config;
  }

}
